module.exports = __webpack_public_path__ + "img/personaje-3.5fe2a87f.png";